import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './app/router';
import './assets/styles.css';
import { listenLorUsAppInstall } from './features/pwa/lor-us-app-install';
import { isOroMxSkin } from './shared/theme/active-skin';

function setupDevtoolsDeterrent() {
  if (
    !import.meta.env.PROD ||
    import.meta.env.VITE_SECURITY_DEVTOOLS_DETERRENT !== 'true'
  ) {
    return;
  }

  const blockedKeys = new Set(['F12']);
  document.addEventListener('contextmenu', (event) => event.preventDefault());
  document.addEventListener('keydown', (event) => {
    const key = event.key.toUpperCase();
    const isDevtoolsShortcut =
      blockedKeys.has(event.key) ||
      ((event.ctrlKey || event.metaKey) &&
        event.shiftKey &&
        ['C', 'I', 'J'].includes(key)) ||
      ((event.ctrlKey || event.metaKey) && key === 'U');

    if (isDevtoolsShortcut) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}

setupDevtoolsDeterrent();

// beforeinstallprompt 只在加载早期触发一次，等页脚挂载再监听会错过。
if (isOroMxSkin) listenLorUsAppInstall();

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');
